<form [formGroup]="newGameNotificationSettingsForm" (change)="onFormChange()">
  <mat-form-field appearance="outline" class="full-width margin-top-large">
    <mat-label>Draw Notifications Start Time</mat-label>
    <input formControlName="notificationsBeginMinutesBeforeDraw" data-testid="draw-notification-start-time-input"
           placeholder="enter time you would like to send notifications" matInput>
    <mat-hint>Time to start sending notifications on draw day. Please enter as military time (14:00 = 2pm, 07:00 = 7am)</mat-hint>
    <mat-error data-testid="notifications-start-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw.errors && (newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw.touched || newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width margin-top-large">
    <mat-label>Draw Notifications End Time</mat-label>
    <input formControlName="notificationsEndMinutesBeforeDraw" data-testid="draw-notification-end-time-input"
           placeholder="enter time you would like to stop sending notifications" matInput>
    <mat-hint>Time to stop sending notifications on draw day. Please enter as military time (14:00 = 2pm, 07:00 = 7am)</mat-hint>
    <mat-error data-testid="notifications-end-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw.errors && (newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw.touched || newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width margin-top-large">
    <mat-label>Notification Frequency (seconds)</mat-label>
    <input type="number"
           formControlName="notificationFrequency"
           data-testid="notification-frequency-input"
           placeholder="enter notification frequency in seconds"
           matInput>
    <mat-hint>How often notifications should be sent between start and end times (in seconds). Example: 3600 seconds = 1 hour, 1800 seconds = 30 minutes
    </mat-hint>
    <mat-error data-testid="notification-frequency-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationFrequency.errors && (newGameNotificationSettingsForm.controls.notificationFrequency.touched || newGameNotificationSettingsForm.controls.notificationFrequency.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width margin-top-large">
    <mat-label>Notification Chunk Size</mat-label>
    <input type="number"
           formControlName="notificationChunkSize"
           data-testid="notification-chunk-size-input"
           placeholder="enter chunk size for notification batches"
           matInput>
    <mat-hint>Number of notifications to send in each batch.
    </mat-hint>
    <mat-error data-testid="notification-chunk-size-error"
               *ngIf="newGameNotificationSettingsForm.controls.notificationChunkSize.errors && (newGameNotificationSettingsForm.controls.notificationChunkSize.touched || newGameNotificationSettingsForm.controls.notificationChunkSize.dirty)">
      required
    </mat-error>
  </mat-form-field>

  <mat-checkbox class="margin-top-large" formControlName="sendLastFourDigits">Send Last Four Digits of Winning Credit Card Number to Organization</mat-checkbox>
</form>
